"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _reactRouter = require("react-router");

var _reactRedux = require("react-redux");

var _components = require("components");

var _DescriptionWith3Columns = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/DescriptionWith3Columns");

var _DescriptionWith3Columns2 = _interopRequireDefault(_DescriptionWith3Columns);

var _Home = require("../Home/Home");

var _QouteSection = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/QouteSection");

var _QouteSection2 = _interopRequireDefault(_QouteSection);

var _Slider = require("@quixeltools/quixel-ui-library/dist/components/common/website/Slider");

var _Slider2 = _interopRequireDefault(_Slider);

var _VideoLinkSection = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/VideoLinkSection");

var _VideoLinkSection2 = _interopRequireDefault(_VideoLinkSection);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _utils = require("utils");

var _cloudFront = require("../../utils/cloudFront");

var cf_utils = _interopRequireWildcard(_cloudFront);

var _TextButton = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/TextButton");

var _TextButton2 = _interopRequireDefault(_TextButton);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _config = require("../../config");

var _config2 = _interopRequireDefault(_config);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Megascans = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    loggedIn: state.auth.loggedIn,
    user: state.user
  };
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(Megascans, _React$Component);

  function Megascans(props) {
    (0, _classCallCheck3.default)(this, Megascans);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Megascans.__proto__ || (0, _getPrototypeOf2.default)(Megascans)).call(this, props));

    _this.state = {
      platform: "Windows",
      isOpened: false
    };
    _this.renderContactUsForm = _this.renderContactUsForm.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Megascans, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var platform = (0, _utils.detectOperatingSystem)();
      this.setState({ platform: platform });
    }
  }, {
    key: "renderContactUsForm",
    value: function renderContactUsForm(title, description, tag, initialValues) {
      this.context.dialogs.custom(_react2.default.createElement(_components.ContactUsPopupContainer, {
        title: title,
        description: description,
        tag: tag,
        initialValues: {
          name: _ramda2.default.propOr("", "name", initialValues),
          email: _ramda2.default.propOr("", "email", initialValues),
          subject: _ramda2.default.propOr("", "subject", initialValues),
          comment: _ramda2.default.propOr("", "comment", initialValues)
        }
      }));
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.user !== this.props.user) {
        var hash = nextProps.location.hash;
        if (hash && hash.length) {
          if (hash.indexOf("#") == 0) {
            hash = hash.slice(1);
          }
          if (hash === "contactUs" && !this.state.isOpened) {
            if (nextProps.loggedIn) {
              this.setState({
                isOpened: true
              });
              this.renderContactUsForm("We are here to help!", "Leave us a note and we will get back to you soon.", "About Us", { email: nextProps.user.email });
            }
          }
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        _components.AppSideEffects,
        {
          documentTitle: "- We capture the world so you can create your own",
          documentImage: cf_utils.cf_thumbs("page-thumb-megascans.jpg"),
          documentDescription: "Learn about our history in 3D scanning and developing software and exploring new ways of working for the entire industry." },
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(_components.Hero, {
            className: (0, _glamor.css)({ "& h3": { textTransform: "uppercase" } }),
            bg: cf_utils.cf_qx_page("about", "quixel-about-herovideo-fallback.jpeg"),
            opacity: 0.25,
            backgroundVideo: {
              poster: cf_utils.cf_qx_page("about", "quixel-about-herovideo-fallback.jpeg"),
              loop: "true",
              src: cf_utils.cf_qx_page("about", "Quixel-About-Herovideo.mp4")
            },
            superIconUrls: [cf_utils.cf_icons("quixel_logo.png")],
            title: "We capture the world",
            subTitle: "So that you can create your own.",
            primaryLabel: "",
            primaryTo: ""
          }),
          _react2.default.createElement(_components.Feature, {
            featureType: " ",
            title: "about us",
            newHome: true,
            desc: "Quixel powers one of the world\u2019s largest photogrammetry asset library and bundled toolset: Megascans, Bridge and Mixer \u2014 forming a robust content creation ecosystem for producing high-quality 3D content. Today's leading teams and artists in cinematic VFX, AAA game development and architectural visualization use our products in their most ambitious productions.",
            link: [{
              href: "https://youtu.be/5ZjwwtMlNCU",
              label: "See our product video",
              newWindow: true
            }],
            images: [cf_utils.cf_qx_page("about", "02a-Quixel-About-AboutUs.jpg"), cf_utils.cf_qx_page("about", "02b-Quixel-About-AboutUs-Bridge.jpg"), cf_utils.cf_qx_page("about", "02C-Quixel-About-AboutUs-Mixer.jpg")],
            artists: ["MEGASCANS USED WITH UNREAL ENGINE 5", "QUIXEL BRIDGE", "TEXTURED WITH QUIXEL MIXER"]
          }),
          _react2.default.createElement(_components.Feature, {
            featureType: " ",
            img: cf_utils.cf_qx_page("about", "03-Quixel-About-AboutUs-History.jpg"),
            title: "HISTORY",
            newHome: true,
            desc: "Quixel was founded in 2011 by Teddy Bergsman and Waqar Azim, based on the vision of substantially speeding up how creators build photorealistic environments, by giving them access to a vast and ever-expanding library of scanned 3D assets, and easy-to-use tools. Now part of the Epic Games family, our mission is to enable creators to easily make high-quality experiences by simplifying world creation.",
            flip: true,
            link: [{
              href: "https://www.youtube.com/watch?v=wd_sdFaYdIk",
              label: "JOINING FORCES WITH EPIC GAMES",
              newWindow: true
              // onClick:()=>(__CLIENT__ ? window.location=window.location.protocol+'//'+window.location.hostname+'/megascans/library/':'')
            }]
          }),
          _react2.default.createElement(_components.Feature, {
            featureType: " ",
            images: [cf_utils.cf_qx_page("about", "04a-Quixel-About-Locations.jpg"), cf_utils.cf_qx_page("about", "04b-Quixel-About-Locations.jpg"), cf_utils.cf_qx_page("about", "04c-Quixel-About-Locations.jpg"), cf_utils.cf_qx_page("about", "04d-Quixel-About-Locations.jpg")],
            title: "locations",
            newHome: true,
            desc: "The Quixel team is headquartered in Sweden and has, combined, over 250 employees and contributors across 6 continents \u2014 who have a strong background in the games and VFX industries and a very active presence in the community.",
            link: [{
              label: "contact us",
              onClick: function onClick() {
                window.open(_config2.default.forumBaseUrl, "_blank");
              }
            }]
          }),
          _react2.default.createElement(_components.Feature, {
            featureType: " ",
            img: cf_utils.cf_qx_page("about", "05-Quixel-About-Join-Us.jpg"),
            title: "join us",
            newHome: true,
            flip: true,
            desc: "We\u2019re always on the lookout for amazing people to join our team. If you\u2019re a technically skilled artist, developer, or creative with a passion for changing how digital industries work today and in the future, we would love to talk to you!",
            link: [{
              href: "/jobs",
              label: "SEE OPEN POSITIONS"
            }]
          }),
          _react2.default.createElement(_components.Feature, {
            featureType: " ",
            img: cf_utils.cf_qx_page("about", "06-Quixel-About-Get-in-touch.jpg"),
            title: "get in touch",
            newHome: true,
            desc: "Reach out to us through our contact form below for technical support, or if you want to discuss sales, sponsorships, partnerships, public relations, and other business opportunities.",
            link: [{
              label: "contact us",
              onClick: function onClick() {
                window.open(_config2.default.forumBaseUrl, "_blank");
              }
            }]
          })
        )
      );
    }
  }]);
  return Megascans;
}(_react2.default.Component), _class2.contextTypes = {
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp)) || _class);
exports.default = Megascans;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/About/About.jsx
// module id = 2101
// module chunks = 0